module.exports = __webpack_public_path__ + "media/images/meeting_points/pin-pointer-a8efe02d007438f31c02b2c9f4d6cefc.png";